<template>
  <div>
    <h2>Dashboard</h2>
    <p>Welcome, {{ user.name }}</p>
    <button @click="logout">Logout</button>
  </div>
</template>

<script>
import { getProfile } from "../services/auth";

export default {
  name: "DashboardPage", // ✅ Multi-word name to satisfy ESLint
  data() {
    return { user: {} };
  },
  async created() {
    try {
      this.user = await getProfile();
    } catch (err) {
      alert("Please login first!");
      this.$router.push("/login");
    }
  },
  methods: {
    logout() {
      localStorage.removeItem("token");
      this.$router.push("/login");
    },
  },
};
</script>
